export const GET_SELLERS = "@iweb/GET_SELLERS"
export const UPDATE_SELLER_CATEGORY = "@iweb/UPDATE_SELLER_CATEGORY"
export const UPDATE_SELLER_DATA = "@iweb/UPDATE_SELLER_DATA"
export const UPDATE_SELLER_REVIEW = "@iweb/UPDATE_SELLER_REVIEW"
export const UPDATE_SELLER_AVERAGE_REVIEW = "@iweb/UPDATE_SELLER_AVERAGE_REVIEW"
export const SET_BRIEF_SELLERS = Symbol("SET_BRIEF_SELLERS")
